import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@/components/form/baseInputs/Button';
import { PlusIcon } from '@/components/icons/PlusIcon';
import {
  BehaviorAuthorizationType,
  useHasBehaviorAuthorization,
} from '@/modules/authentication/hooks/useHasBehaviorAuthorization';

import { CreateCollaboratorModal } from './CollaboratorModal/CreateCollaboratorModal';
import { InviteColleagueModal } from './InviteColleagueModal/InviteColleagueModal';

/** Search param to open the invite colleague modal on page load */
export const OPEN_INVITE_COLLEAGUE_SEARCH_PARAM = 'openInviteColleague';

export function CollaboratorsPageActions() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isCreateCollaboratorModalOpen, setIsCreateCollaboratorModalOpen] =
    useState(false);
  const [isInviteColleagueModalOpen, setIsInviteColleagueModalOpen] =
    useState(false);

  // Open invite colleague modal if search param is present
  useEffect(() => {
    if (searchParams.get(OPEN_INVITE_COLLEAGUE_SEARCH_PARAM) === 'true') {
      setIsInviteColleagueModalOpen(true);
      // Remove the search param after opening the modal
      searchParams.delete(OPEN_INVITE_COLLEAGUE_SEARCH_PARAM);
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);
  const canEditCollaborator = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_EDIT_COLLABORATORS
  );

  if (!canEditCollaborator) {
    return null;
  }

  const handleOpenInviteColleagueModal = () => {
    setIsCreateCollaboratorModalOpen(false);
    setIsInviteColleagueModalOpen(true);
  };

  return (
    <>
      {isInviteColleagueModalOpen && (
        <InviteColleagueModal
          isOpen={isInviteColleagueModalOpen}
          onClose={() => setIsInviteColleagueModalOpen(false)}
        />
      )}
      {isCreateCollaboratorModalOpen && (
        <CreateCollaboratorModal
          isOpen={isCreateCollaboratorModalOpen}
          onClose={() => setIsCreateCollaboratorModalOpen(false)}
          onOpenInviteColleague={handleOpenInviteColleagueModal}
        />
      )}
      <Stack direction="row" spacing={1}>
        <Button
          onClick={() => setIsInviteColleagueModalOpen(true)}
          variant="secondary"
          size="sm"
          startIcon={PlusIcon}
        >
          Invite colleague
        </Button>
        <Button
          onClick={() => setIsCreateCollaboratorModalOpen(true)}
          variant="primary"
          size="sm"
          startIcon={PlusIcon}
        >
          Add external collaborator
        </Button>
      </Stack>
    </>
  );
}
